import { ChapterLabel } from "./ChapterLabel";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    step: "01",
    title: "We Review",
    text: "We audit your website, Google presence, and lead response time.",
  },
  {
    step: "02",
    title: "You Get a Report",
    text: "A clear, monthly report showing what's working and what's not.",
  },
  {
    step: "03",
    title: "We Walk You Through It",
    text: "A quick call each month to explain the findings and next steps.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 sm:py-32" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterLabel text="Chapter 04 // The Method" />
        <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-tight text-white mb-16">
          How It Works
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {STEPS.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.12}>
            <div
              data-testid={`how-it-works-step-${i + 1}`}
              className="relative h-full rounded-2xl sm:rounded-3xl border border-white/10 p-8 sm:p-10 overflow-hidden"
            >
              <span className="font-display absolute -top-6 -right-2 text-[7rem] font-extrabold text-white/[0.05] leading-none select-none">
                {s.step}
              </span>
              <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-500 mb-6">
                Step {s.step}
              </p>
              <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-white mb-3">
                {s.title}
              </h3>
              <p className="text-base text-slate-400 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
